import { minBreakpoints, primaryRegularFont, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, smallElevation } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const partner = css`
  align-items: center;
  grid-row-gap: ${spacing.md}px;
`;

export const imageWrapper = css`
  grid-column: span 4;
  display: grid;
  align-items: center;
  justify-content: center;
  position: relative;
  top: -${spacing.md}px;
  padding: ${spacing.base}px;
  aspect-ratio: 1 / 1;
  background-color: var(--neutral-white-base);
  border-radius: ${spacing.sm}px;
  ${smallElevation};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: span 3;
    `,
  )}
`;

export const image = css`
  max-width: 100%;
`;

export const content = css`
  grid-column: span 8;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-column: span 4;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: span 6;
    `,
  )}
`;

export const heading = css`
  ${responsiveText.HEADING.XS};
  color: var(--brand-purple-base);
  margin: 0 0 ${spacing.xs}px 0;
  ${primaryRegularFont};
  > a {
    text-decoration: none;
  }
`;

export const infoItems = css`
  margin: 0;
  padding: 0;
  list-style-type: none;
  color: var(--neutral-black-base);
  ${responsiveText.BODY.SM};

  li {
    margin: 0 0 ${spacing.xs}px 0;

    span {
      display: inline-block;
      margin-right: 5px;
      vertical-align: text-bottom;
    }
  }

  a {
    font-weight: bold;
    text-decoration: none;
  }
`;

export const buttons = css`
  grid-column: span 12;
  display: flex;
  justify-content: center;
  gap: ${spacing.xl}px;
  align-items: center;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-column: span 4;
      flex-direction: column;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: span 3;
    `,
  )}
`;

export const button = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${spacing.xs}px;
  padding: ${spacing.xs}px;
  border: 1px solid var(--brand-purple-base);
  background-color: transparent;
  width: 158px;
  height: 30px;
  border-radius: ${spacing.base}px;
  color: var(--brand-purple-base);
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  ${primaryRegularFont};
  ${responsiveText.BODY.SM};
  font-weight: 600;

  &:hover {
    background-color: var(--brand-purple-dark);
  }

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      padding: ${spacing.sm}px;
    `,
  )}
`;
